import {Vec2} from "../../../../../Utils/ThreeJS/VectorStructs.js";

export class PathFill {
	constructor(data?: Partial<PathFill>) { Object.assign(this, data); }

	/** When true, the fill-mesh is not rendered in the map-ui. */
	renderDisabled?: boolean|n;

	// geometry
	zOffset: number|n;

	// styling
	color: number[]|n;
	opacity?: number|n; // opacity of the mesh, 0-1
	texture_id: string|n;
	texture_size: Vec2|n;
	texture_rotation: number|n; // rotation in degrees (clockwise)
}